// FCM Token 获取工具 - 通过 JSBridge 从 App 获取推送Token
/**
 * 从 App 的 JSBridge 异步获取 FCM Token
 * @returns Promise<string> 返回 FCM Token
 * @throws 当 AndroidShell 不可用或获取失败时抛出错误
 */
export function getFCMTokenFromApp(): Promise<string> {
    return new Promise( ( resolve, reject ) => {
        console.log( "[Debug] getFCMTokenFromApp start execution" );
        console.log( "[Debug] window.AndroidShell:", window.AndroidShell );
        console.log( "[Debug] getFCMToken method:", window.AndroidShell?.getFCMToken );
        const callbackName = "fcmCallback_" + Date.now();

        window[callbackName] = function( token: string ) {
            console.log( "[Debug] Callback function called, token:", token );
            delete window[callbackName];
            if ( token ) {
                resolve( token );
            } else {
                reject( new Error( "Failed to get FCM token" ) );
            }
        };

        if ( window.AndroidShell && window.AndroidShell.getFCMToken ) {
            console.log( "[Debug] Calling AndroidShell.getFCMToken, callback:", callbackName );
            window.AndroidShell.getFCMToken( callbackName );
        } else {
            console.error( "[Debug] AndroidShell not available" );
            reject( new Error( "AndroidShell not available" ) );
        }
    } );
}
